export const aboutInfo = {
  brand: {
    name: "爱液视频",
    slogan: "正版高清，极速畅享",
    founded: "2018年",
    description: "爱液视频是领先的正版高清视频平台，致力于为用户提供海量优质视频内容和极致观影体验。平台汇聚了电影、电视剧、综艺、动漫、纪录片、少儿等多品类正版内容，覆盖全球主流影视资源。",
    mission: "让每一位用户都能便捷地享受正版高清视频内容，推动中国视频行业的健康发展。",
    vision: "成为最受用户信赖的综合视频平台，用科技与内容驱动数字娱乐的未来。",
    values: [
      { title: "正版承诺", description: "坚持正版内容采购，保障创作者权益，为用户提供合法合规的观影环境。" },
      { title: "品质至上", description: "从内容筛选到技术实现，每一个环节都追求卓越品质，打造极致体验。" },
      { title: "用户为本", description: "以用户需求为导向，持续优化产品体验，提供贴心周到的服务。" },
      { title: "创新驱动", description: "积极探索新技术、新模式，用创新推动视频行业的进步与发展。" },
    ],
    stats: [
      { value: "5000万+", label: "注册用户" },
      { value: "10万+", label: "正版内容" },
      { value: "99.9%", label: "服务可用率" },
      { value: "4.9分", label: "用户评分" },
    ],
  },
  timeline: [
    { year: "2018", event: "爱液视频正式上线，开启正版视频服务" },
    { year: "2019", event: "注册用户突破500万，完成A轮融资" },
    { year: "2020", event: "推出4K超清画质服务，用户突破2000万" },
    { year: "2021", event: "上线杜比全景声，合作内容方超过500家" },
    { year: "2022", event: "推出家庭会员计划，日活跃用户突破1000万" },
    { year: "2023", event: "荣获年度最佳视频平台奖，用户突破4000万" },
    { year: "2024", event: "全面升级AI推荐算法，注册用户超过5000万" },
  ],
  testimonials: [
    {
      name: "张先生",
      role: "资深影迷",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20man%20in%20his%2030s%2C%20warm%20friendly%20smile%2C%20clean%20white%20background%2C%20professional%20headshot%20style%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-01&orientation=squarish",
      content: "用了爱液视频三年了，画质和片源都是一流的。4K超清看大片特别爽，推荐给大家！",
      rating: 5,
    },
    {
      name: "李女士",
      role: "全职妈妈",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20woman%20in%20her%2030s%2C%20gentle%20warm%20smile%2C%20clean%20white%20background%2C%20professional%20headshot%20style%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-02&orientation=squarish",
      content: "少儿频道的内容特别丰富，孩子每天都很喜欢看，内容健康放心，家长管控功能也很实用。",
      rating: 5,
    },
    {
      name: "王同学",
      role: "大学生",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Chinese%20man%20in%20his%2020s%2C%20bright%20confident%20smile%2C%20clean%20white%20background%2C%20professional%20headshot%20style%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-03&orientation=squarish",
      content: "纪录片频道太良心了！很多BBC和Discovery的正版纪录片，学习娱乐两不误。",
      rating: 5,
    },
  ],
  contact: {
    address: "北京市朝阳区建国路88号SOHO现代城A座18层",
    phone: "400-888-9999",
    email: "service@aiyevideo.com",
    workingHours: "周一至周日 9:00 - 21:00",
    socialMedia: {
      weibo: "爱液视频官方微博",
      wechat: "aiyevideo",
      douyin: "爱液视频",
    },
  },
};

export const faqList = [
  {
    question: "爱液视频提供什么样的画质？",
    answer: "爱液视频提供从标清到4K超高清的多档画质选择。高级会员可享受4K超清画质和杜比全景声，基础会员可享受1080P全高清画质。画质会根据您的网络状况自动调整，确保流畅播放。",
  },
  {
    question: "如何注册成为爱液视频会员？",
    answer: "您可以通过爱液视频官网或App进行注册。点击右上角「注册」按钮，输入手机号或邮箱，设置密码后即可完成注册。新用户注册即可获得7天免费会员体验。",
  },
  {
    question: "会员可以在几个设备上同时使用？",
    answer: "基础会员支持1个设备同时在线观看，高级会员支持2个设备，家庭会员支持最多5个设备同时在线。每个设备都有独立的观看记录和个性化推荐。",
  },
  {
    question: "支持哪些设备观看？",
    answer: "爱液视频支持全平台观看，包括：Web网页端、iOS App、Android App、智能电视（TV版）、平板电脑等。所有设备之间可无缝切换，观看进度自动同步。",
  },
  {
    question: "如何取消自动续费？",
    answer: "您可以在「我的」-「会员中心」-「订阅管理」中随时关闭自动续费。关闭后当前会员周期结束后不会自动扣费，您仍可在有效期内继续享受会员权益。",
  },
  {
    question: "视频可以下载离线观看吗？",
    answer: "可以。高级会员和家庭会员支持将视频下载到本地设备进行离线观看。下载的视频在会员有效期内可随时观看，部分版权内容可能有下载次数限制。",
  },
  {
    question: "遇到播放问题怎么办？",
    answer: "如果您遇到播放卡顿、黑屏等问题，建议先尝试：1）检查网络连接；2）清除浏览器缓存；3）切换播放画质；4）更新App至最新版本。如果问题仍然存在，请联系客服热线400-888-9999。",
  },
];